<div mat-dialog-title class="title">
    <span class="heading">{{clientOffice}} Payment Request - ({{typeOfPayment}})</span>
    <button (click)="closeDialog()" mat-dialog-close class="close-button" mat-icon-button matSuffix>
        <mat-icon class="close-icon-color">cancel</mat-icon>
    </button>
</div>
<div class="dialog-wrapper">
    <div class="form-container">
        <form [formGroup]="paymentRequestForm">
            <mat-form-field class="fullLength" *ngIf="showReturnReason">
                <mat-label style="color: red;">Rejected Reason</mat-label>
                <input matInput formControlName="returnReason" readonly>
            </mat-form-field>

            <mat-form-field *ngIf="!isInternational" class="halfLength">
                <mat-label>Payment method</mat-label>
                <mat-select formControlName="chapsRequired" (selectionChange)="onPaymentMethodChange($event.value)">
                    <mat-option *ngFor="let method of paymentMethodDropdown"
                                [value]="method">
                        {{method}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="paymentRequestForm.get('chapsRequired')?.invalid">Please select a valid payment method.</mat-error>
            </mat-form-field>

            <mat-checkbox *ngIf="showPropertyPurchaseCheckbox && !isInternational" formControlName="isPropertyPurchase" (change)="onPropertyPurchaseChange($event)">
                Is this transaction related to a property purchase?
            </mat-checkbox>

            <mat-form-field *ngIf="showPurposeCodeDropdown && !isInternational" class="halfLength">
                <mat-label>Purpose Code</mat-label>
                <mat-select formControlName="purposeCode">
                    <mat-option *ngFor="let purpose of purposeCodeDropdown" [value]="purpose.id">
                        {{ purpose.code }} - {{ purpose.name }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="paymentRequestForm.get('purposeCode')?.hasError('required') && paymentRequestForm.get('purposeCode')?.invalid">
                    Please select a purpose code.
                </mat-error>
            </mat-form-field>

            <div class="search">
                <mat-form-field class="matterAuto">
                    <mat-label>Matter</mat-label>
                    <button *ngIf="paymentRequestForm.get('matter')?.value" (click)="clearSearchFilter()" mat-icon-button matSuffix [disabled]="isDisabled">
                        <mat-icon>clear</mat-icon>
                    </button>
                    <input matInput
                           formControlName="matter"
                           [matAutocomplete]="auto" />
                    <mat-error>Please select a matter.</mat-error>
                </mat-form-field>
                <mat-autocomplete #auto="matAutocomplete">
                    <mat-option *ngIf="isLoading">
                        Loading....
                    </mat-option>
                    <mat-option *ngIf="noData && !isLoading">
                        No matching matters found.
                    </mat-option>
                    <div *ngIf="!isLoading && !noData">
                        <mat-option *ngFor="let item of matterDropdownData"
                                    [value]="displayMatter(item)"
                                    (onSelectionChange)="lookupSelecttionChangd($event)">
                            {{ item.number }} - {{ item.description }}
                        </mat-option>
                    </div>
                </mat-autocomplete>
            </div>

            @if (showLinkToOpenMatter()) {
            <div class="sticky-actionstep-bar">
                <div class="link-wrapper">
                    <a [href]="actionstepMatterUrl"
                       target="_blank"
                       rel="noopener noreferrer">
                        Open Matter in Actionstep ({{ matterNo }})
                    </a>
                    <button type="button" mat-icon-button
                            class="small-copy-btn"
                            [cdkCopyToClipboard]="actionstepMatterUrl"
                            (cdkCopyToClipboardCopied)="onUrlCopied()"
                            matTooltip="Copy link to clipboard"
                            matTooltipPosition="below">
                        <mat-icon>content_copy</mat-icon>
                    </button>
                </div>
                <div class="warning-box">
                    You must be logged into Actionstep under the same jurisdiction.
                </div>
            </div>
            }

            <div class="field-wrap">
                <mat-form-field class="client-field">
                    <mat-label>Client Name</mat-label>
                    <input matInput formControlName="clientName" readonly />
                    <mat-progress-spinner *ngIf="isLoading"
                                          class="spinner-padding"
                                          matSuffix
                                          mode="indeterminate"
                                          diameter="20"
                                          strokeWidth="3">
                    </mat-progress-spinner>
                </mat-form-field>

                @if(showDateTransaction()){
                    <div class="date-time-row">
                        <mat-form-field color="accent" class="date-field">
                            <mat-label>Transaction Date</mat-label>
                            <input matInput [matDatepicker]="transactionDatePicker" formControlName="dateTransaction" />
                            <mat-datepicker-toggle matSuffix [for]="transactionDatePicker" />
                            <mat-datepicker #transactionDatePicker />
                            @if (paymentRequestForm.get('dateTransaction')?.touched && paymentRequestForm.get('dateTransaction')?.invalid) {
                            <mat-error>Please select a date.</mat-error>
                            }
                        </mat-form-field>

                        <mat-form-field color="accent" class="time-field">
                            <mat-label>Transaction Time</mat-label>
                            <input matInput
                                   type="time"
                                   formControlName="transactionTime" />
                        </mat-form-field>
                    </div>
                }
            </div>

            <div class="form">
                <mat-form-field class="fullLength">
                    <mat-label>Are monies being returned directly to the client?</mat-label>
                    <mat-select formControlName="isMoniesReturned">

                        <mat-option [value]="true">Yes</mat-option>
                        <mat-option [value]="false">No</mat-option>
                    </mat-select>
                    <mat-error *ngIf="paymentRequestForm.get('isMoniesReturned')?.invalid">
                        Please select Yes or No.
                    </mat-error>
                </mat-form-field>


                @if(paymentRequestForm.get('isMoniesReturned')?.value === false){
                <mat-form-field class="fullLength">
                    <mat-label>If no, please explain.</mat-label>
                    <textarea matInput formControlName="returnMoniesExplanationIfNo"></textarea>
                    @if (paymentRequestForm.get('returnMoniesExplanationIfNo')?.touched && paymentRequestForm.get('returnMoniesExplanationIfNo')?.hasError('required')) {
                    <mat-error>
                        Please provide an explanation if monies are not being returned directly to the client.
                    </mat-error>
                    }
                </mat-form-field>
                }

                <mat-form-field class="fullLength">
                    <mat-label>Reason for payment</mat-label>
                    <textarea matInput formControlName="reason"></textarea>
                    <mat-error *ngIf="paymentRequestForm.get('reason')?.hasError('required')">
                        Reason for payment is required when selecting No.
                    </mat-error>
                </mat-form-field>

                @if(isUserPartner){
                <mat-form-field class="fullLength">
                    <mat-label>Are you the matter partner on this matter?</mat-label>
                    <mat-select formControlName="matterPartner">
                        <mat-option [value]="true">Yes</mat-option>
                        <mat-option [value]="false">No</mat-option>
                    </mat-select>
                </mat-form-field>
                }

                <mat-form-field class="fullLength" *ngIf="isUserPartner && !paymentRequestForm.get('matterPartner')?.value">
                    <mat-label>Reason for requesting payment on a matter you are not the matter partner for</mat-label>
                    <textarea matInput formControlName="nonPartnerReason"></textarea>
                    <mat-error *ngIf="paymentRequestForm.get('nonPartnerReason')?.hasError('required')">
                        Reason is required when selecting No.
                    </mat-error>
                </mat-form-field>

                @if(isInternational || paymentRequestForm.get('chapsRequired')?.value === 'CHAPS'){
                <mat-form-field class="fullLength">
                    <mat-label>Address</mat-label>
                    <textarea matInput formControlName="address" [required]="!!isInternational"></textarea>
                    <mat-error *ngIf="paymentRequestForm.get('address')?.touched && paymentRequestForm.get('address')?.hasError('required')">
                        Address for payment is required.
                    </mat-error>
                </mat-form-field>
                }

                <div class="header">
                    Payment
                </div>
                <div class="date-time-row">
                    <mat-form-field color="accent" class="date-field">
                        <mat-label>Requested Date</mat-label>
                        <input matInput [matDatepicker]="requestedDatePicker" formControlName="dateRequested" placeholder="dd/MM/yyyy" [max]="currentDate"/>
                        <mat-datepicker-toggle matSuffix [for]="requestedDatePicker" />
                        <mat-datepicker #requestedDatePicker />
                        @if (paymentRequestForm.get('dateRequested')?.touched && paymentRequestForm.get('dateRequested')?.invalid) {
                        <mat-error>Please select a date.</mat-error>
                        }
                    </mat-form-field>

                    <mat-form-field color="accent" class="time-field">
                        <mat-label>Requested Time</mat-label>
                        <input matInput type="time" formControlName="requestedTime" placeholder="HH:mm" />
                        @if (paymentRequestForm.get('requestedTime')?.touched && paymentRequestForm.get('requestedTime')?.invalid) {
                        <mat-error>Please enter a time.</mat-error>
                        }
                    </mat-form-field>
                </div>

                @if (showPayeeSelect) {
                <mat-form-field>
                    <mat-label>Payee</mat-label>
                    <mat-select multiple required panelClass="sw-multi-select-panel" [formControl]="payeeClients"
                                [errorStateMatcher]="payeeErrorMatcher"
                                (selectionChange)="onPayeeClientsChange()"
                                (openedChange)="onPayeeSelectOpened($event)">
                        @for (name of clientOptions; track name) {
                        <mat-option [value]="name">{{ name }}</mat-option>
                        }
                    </mat-select>
                    <mat-error>Please select at least one payee.</mat-error>
                </mat-form-field>
                } @else {
                <mat-form-field>
                    <mat-label>Payee</mat-label>
                    <input matInput formControlName="name" />
                    <mat-progress-spinner *ngIf="isLoading" class="spinner-padding" matSuffix mode="indeterminate" diameter="20" strokeWidth="3"></mat-progress-spinner>
                    <mat-error *ngIf="paymentRequestForm.get('name')?.invalid">Please enter a valid payee.</mat-error>
                </mat-form-field>
                }

                <div [ngClass]="{'form': paymentType}">
                    <mat-form-field [ngClass]="{'w-100': !paymentType}">
                        <mat-label>Amount</mat-label>
                        @if (!isInternational) {
                        <span matTextPrefix>£&nbsp;</span>
                        }
                        <input matInput
                               formControlName="amount"
                               type="text"
                               (keydown)="validateInput($event)"
                               maxlength="15"
                               [value]="displayValue" (blur)="formatNumber()" appCurrencyInput />
                        <mat-error *ngIf="paymentRequestForm.get('amount')?.invalid">Please enter a valid amount.</mat-error>
                    </mat-form-field>
                    <mat-form-field *ngIf="paymentType">
                        <mat-label>VAT Amount</mat-label>
                        <input matInput
                               formControlName="vatAmount"
                               type="text"
                               (keydown)="validateInput($event)"
                               maxlength="15"
                               [value]="vatDisplayValue"
                               (blur)="formatVatNumber()" />
                        <mat-error *ngIf="paymentRequestForm.get('vatAmount')?.invalid">Please enter a valid VAT amount.</mat-error>
                    </mat-form-field>
                </div>
                <mat-form-field>
                    <mat-label>Client Bank</mat-label>
                    <mat-select formControlName="clientBankAccount">
                        <mat-option *ngFor="let account of filteredBankAccounts" [value]="account">
                            {{ account.accountId }} - {{ account.description }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                @if (showLinkToOpenMatter()) {
                <div class="actionstep-matter-overview">
                    <div class="link-wrapper">
                        <a [href]="actionstepMatterOverviewUrl"
                           target="_blank"
                           rel="noopener noreferrer">
                            Open Actionstep Matter ({{ matterNo }}) Overview
                        </a>
                        <button type="button" mat-icon-button
                                class="small-copy-btn"
                                [cdkCopyToClipboard]="actionstepMatterOverviewUrl"
                                (cdkCopyToClipboardCopied)="onUrlCopied()"
                                matTooltip="Copy link to clipboard"
                                matTooltipPosition="below">
                            <mat-icon>content_copy</mat-icon>
                        </button>
                    </div>
                    <div class="warning-box">
                        You must be logged into Actionstep under the same jurisdiction.
                    </div>
                </div>
                }

                <mat-form-field *ngIf="isInternational">
                    <mat-label>Currency</mat-label>

                    <mat-select formControlName="currency">
                        <mat-option *ngFor="let c of currencyDropdown"
                                    [value]="c.id">
                            {{c.currencyCode}} - {{c.symbol}}
                        </mat-option>
                    </mat-select>
                    <mat-error>Please select currency code.</mat-error>
                </mat-form-field>

                <div class="header" *ngIf="isInternational">
                    Intermediate Bank (if any)
                </div>
                <mat-form-field *ngIf="!isInternational">
                    <mat-label>Bank</mat-label>
                    <input matInput formControlName="bankName" />
                    <mat-error>Please enter the name of the bank.</mat-error>
                </mat-form-field>
                <mat-form-field *ngIf="isInternational">
                    <mat-label>Bank</mat-label>
                    <input matInput formControlName="intermBankName" />
                    <mat-error *ngIf="paymentRequestForm.get('intermBankName')?.invalid">Please enter the name of the bank.</mat-error>
                </mat-form-field>
                <div *ngIf="!isInternational" class="form">
                    <mat-form-field>
                        <mat-label>Sort code</mat-label>
                        <input matInput maxlength="6" inputmode="numeric" formControlName="sortCode"
                               (keypress)="allowOnlyDigits($event)" (input)="sanitizeSortCode($event)" />
                        <mat-error *ngIf="paymentRequestForm.get('sortCode')?.invalid">Please enter a valid 6-digit sort code. eg. 123456</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Account number</mat-label>
                        <input type="text" maxlength="34" matInput formControlName="accountNo" />
                        <mat-error *ngIf="paymentRequestForm.get('accountNo')?.invalid">Please enter a valid account number.</mat-error>
                    </mat-form-field>
                </div>

                <mat-form-field *ngIf="!isInternational">
                    <mat-label>Payee reference</mat-label>
                    <input matInput formControlName="reference" />
                    <mat-error *ngIf="paymentRequestForm.get('reference')?.invalid">Please enter a valid payee reference.</mat-error>
                </mat-form-field>
                <mat-form-field *ngIf="isInternational">
                    <mat-label>Intermediary account number / IBAN</mat-label>
                    <input maxlength="34" type="text" matInput formControlName="intermAccountNo" />
                    <mat-error *ngIf="paymentRequestForm.get('intermAccountNo')?.invalid">Please enter a valid intermediary account number / IBAN.</mat-error>
                </mat-form-field>
                <mat-form-field *ngIf="isInternational">
                    <mat-label>Intermediary SWIFT / BIC code</mat-label>
                    <input matInput type="text" maxlength="11" formControlName="intermSwift" />
                    <mat-error *ngIf="paymentRequestForm.get('intermSwift')?.invalid">Please enter a valid intermediary SWIFT / BIC code.</mat-error>
                </mat-form-field>
                <mat-form-field *ngIf="isInternational">
                    <mat-label>Reference</mat-label>
                    <input matInput formControlName="interReference" />
                    <mat-error *ngIf="paymentRequestForm.get('interReference')?.invalid">Please enter a valid reference.</mat-error>
                </mat-form-field>

                <div class="header" *ngIf="isInternational">
                    Final Bank
                </div>
                <mat-form-field *ngIf="isInternational">
                    <mat-label>Bank</mat-label>
                    <input matInput formControlName="bankName" />
                    <mat-error *ngIf="paymentRequestForm.get('bankName')?.invalid">Please enter the name of the bank.</mat-error>
                </mat-form-field>
                <mat-form-field *ngIf="isInternational">
                    <mat-label>Final beneficiary account number / IBAN</mat-label>
                    <input maxlength="34" type="text" matInput formControlName="finalBeneficiaryAccNo" />
                    <mat-error *ngIf="paymentRequestForm.get('finalBeneficiaryAccNo')?.invalid">Please enter a valid final beneficiary account number / IBAN.</mat-error>
                </mat-form-field>
                <mat-form-field *ngIf="isInternational">
                    <mat-label>Final beneficiary SWIFT / BIC code</mat-label>
                    <input matInput type="text" maxlength="11" formControlName="finalBeneficiarySwift" />
                    <mat-error *ngIf="paymentRequestForm.get('finalBeneficiarySwift')?.invalid">Please enter a valid SWIFT / BIC code.</mat-error>
                </mat-form-field>
                <mat-form-field *ngIf="isInternational">
                    <mat-label>Reference</mat-label>
                    <input matInput formControlName="finalReference" />
                    <mat-error *ngIf="paymentRequestForm.get('finalReference')?.invalid">Please enter a valid Reference.</mat-error>
                </mat-form-field>
                <mat-form-field *ngIf="isInternational">
                    <mat-label>Payee reference</mat-label>
                    <input matInput formControlName="reference" />
                    <mat-error *ngIf="paymentRequestForm.get('reference')?.invalid">Please enter a valid payee reference.</mat-error>
                </mat-form-field>
                <mat-form-field class="fullLength">
                    <mat-label>Note to accounts</mat-label>
                    <textarea matInput class="checkbox-text" formControlName="otherInfo"></textarea>
                    <mat-error *ngIf="paymentRequestForm.get('otherInfo')?.invalid">Please enter information.</mat-error>
                </mat-form-field>
                <div *ngIf="isInternational" class="displayText">
                    International Transfer Fee  of £30 + VAT payable
                </div>

                <mat-form-field class="fullLength">
                    <mat-label>Have the account details been verbally verified by telephone?</mat-label>
                    <mat-select #accountDetailsSelect="matSelect"
                                formControlName="isAccountDetailsVerifies">
                        <mat-option [value]="'Yes'">Yes</mat-option>
                        <mat-option [value]="'No'">No</mat-option>
                    </mat-select>
                    <mat-error *ngIf="paymentRequestForm.get('isAccountDetailsVerifies')?.hasError('required')">
                        Please select Yes or No.
                    </mat-error>
                </mat-form-field>

                <mat-form-field *ngIf="paymentRequestForm.get('isAccountDetailsVerifies')?.value === 'Yes'" color="accent">
                    <mat-label>Date of verification</mat-label>
                    <input matInput [matDatepicker]="verificationDatePicker" [max]="currentDate" formControlName="verificationDate">
                    <mat-datepicker-toggle matSuffix [for]="verificationDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #verificationDatePicker></mat-datepicker>
                    <mat-error *ngIf="paymentRequestForm.get('verificationDate')?.hasError('required')">
                        Please select a date.
                    </mat-error>
                </mat-form-field>

                <mat-form-field *ngIf="paymentRequestForm.get('isAccountDetailsVerifies')?.value === 'Yes'">
                    <mat-label>Who did you speak to?</mat-label>
                    <input matInput formControlName="spokeTo">
                    <mat-error *ngIf="paymentRequestForm.get('spokeTo')?.hasError('required')">
                        Please enter who you spoke to.
                    </mat-error>
                </mat-form-field>

                <mat-form-field *ngIf="paymentRequestForm.get('isAccountDetailsVerifies')?.value === 'No'" class="fullLength">
                    <mat-label>Reason for not confirming details by phone</mat-label>
                    <textarea matInput formControlName="verificationNoReason"></textarea>
                    <mat-error *ngIf="paymentRequestForm.get('verificationNoReason')?.hasError('required')">
                        Please provide a reason.
                    </mat-error>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Partner Authorising</mat-label>
                    <input matInput formControlName="partnerAuthorising" readonly />
                </mat-form-field>

                <mat-form-field appearance="fill" class="upload-doc">
                    <mat-label>Files to upload</mat-label>
                    <input matInput [value]="displayFile.join(', ')" placeholder="Please select a file" readonly [disabled]="isDisabled">
                    <button (click)="fileInput.click()" mat-icon-button matSuffix [disabled]="isDisabled">
                        <mat-icon>upload_file</mat-icon>
                    </button>
                    <button *ngIf="displayFile.length > 0" (click)="clearUpload(fileInput)" mat-icon-button matSuffix>
                        <mat-icon>clear</mat-icon>
                    </button>
                    <input type="file" id="fileInput" (change)="onFilesSelected($event.target)" #fileInput multiple hidden>
                </mat-form-field>
            </div>
        </form>
    </div>
</div>

<div class="action-button" mat-dialog-actions>
    <button mat-raised-button color="accent" type="submit" (click)="delete()" [disabled]="isRejectDisabled">
        Reject
    </button>
    <button mat-raised-button color="accent" type="submit" (click)="withdrawPayment()" [disabled]="isWithdrawDisabled">
        Withdraw Payment
    </button>
    <button mat-raised-button color="accent" type="submit" (click)="approveRequest()" [disabled]="isDisabled || paymentRequestForm.invalid">
        Submit
    </button>
</div>
